export default function PrivacyPolicyLink({
  actionText,
}: {
  actionText: string;
}) {
  const privacyPolicyLink =
    "https://rutterdocs.s3.us-east-2.amazonaws.com/End-user+Privacy+Policy.pdf";

  return (
    <div
      className="text-center pt-2"
      style={{ fontSize: "0.8rem", color: "#949494" }}>
      By selecting "{actionText}" you agree to the{" "}
      <a target="_blank" href={privacyPolicyLink} rel="noreferrer">
        Rutter End User Privacy Policy
      </a>
    </div>
  );
}
